import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAnalyticsInfo } from "../../redux/new-dashboard/dashboardSlice";

function UseFetchAnalyticsInfo() {
  const {
    main: { userData },
    dashboard: { analyticsinfo },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    if (userData?.email && Object.keys(analyticsinfo)?.length === 0) {
      dispatch(
        getAnalyticsInfo(userData?.["custom:custom_username"], userData?.email),
      );
    }
  }, [analyticsinfo, dispatch, userData, userData?.email]);

  return null;
}

export default UseFetchAnalyticsInfo;
